module.exports = "/packs/benefit-thumbnail-80a3aa2f60206dc47cdc320dca73c5c7.png";